/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import { Grid } from "antd";
import React, { useCallback, useEffect, useState, useRef } from "react";
import ChildrenMenu from "./components/ChildrenMenu";
import MainMenu from "./components/MainMenu";

const Menu2025 = (props) => {
  const { homeurl, megacta, search, sitemegamenu } = props;
  // Breakpoints
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { xl } = screens;
  console.log('xl breakpoint:', xl, 'screens:', screens);
  const [activeMenu, setActiveMenu] = useState(null);
  const hoverTimeoutRef = useRef(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);
  const [animationClass, setAnimationClass] = useState('');
  const [lastActiveMenu, setLastActiveMenu] = useState(null);
  
  const handleKeyDown = useCallback(
    (event) => {
      // close menu on "esc" key press
      if (event.key === "Escape") {
        setActiveMenu(null);
      }
    },
    [setActiveMenu],
  );
  
  // Handle hover with delay
  const handleMouseEnter = useCallback(
    (item) => {
      console.log('Mouse enter:', item.title);
      
      // Clear any existing timeout
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
      
      // Set new timeout for hover
      hoverTimeoutRef.current = setTimeout(() => {
        console.log('Setting active menu:', item.title);
        setActiveMenu(item);
      }, 200); // 200ms delay before opening
    },
    [setActiveMenu]
  );
  
  const handleMouseLeave = useCallback(
    () => {
      console.log('Mouse leave');
      
      // Clear any existing timeout
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
      
      // Set timeout for closing
      hoverTimeoutRef.current = setTimeout(() => {
        console.log('Closing menu');
        setActiveMenu(null);
      }, 300); // 300ms delay before closing
    },
    [setActiveMenu]
  );
  
  // Clear hover state when mouse enters submenu
  const handleSubmenuEnter = useCallback(() => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
  }, []);
  
  // Handle menu animation states
  useEffect(() => {
    console.log('Animation effect - activeMenu:', activeMenu);
    if (activeMenu) {
      // Opening animation
      console.log('Opening menu animation');
      setLastActiveMenu(activeMenu); // Preserve menu for animation
      setShouldRender(true);
      // Small delay to ensure DOM is ready for transition
      requestAnimationFrame(() => {
        setAnimationClass('menu2025-entered');
      });
    } else {
      // Closing animation
      console.log('Closing menu animation');
      setAnimationClass('menu2025-exiting');
      // Small delay before hiding to allow animation
      const timer = setTimeout(() => {
        setShouldRender(false);
        setAnimationClass('');
        setLastActiveMenu(null);
      }, 300); // Match transition duration
      return () => clearTimeout(timer);
    }
  }, [activeMenu]);
  
  // add "esc" key event listener on mount
  useEffect(() => {
    //  add event listener
    // eslint-disable-next-line no-undef
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      // remove event listener
      // eslint-disable-next-line no-undef
      document.removeEventListener("keydown", handleKeyDown);
      // Clear timeout on unmount
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };
  }, [handleKeyDown]);

  const homeUrl = `${homeurl}/?s`;

  if (!sitemegamenu) {
    // Fallback for sites without sitemegamenu
    return <div>Menu not configured</div>;
  }

  console.log('Menu2025 render - shouldRender:', shouldRender, 'animationClass:', animationClass, 'lastActiveMenu:', lastActiveMenu);

  // Helper function to get animation classes
  const getMenuContentClasses = () => {
    // Use max-height and opacity for smooth expand/collapse animation
    const baseClasses = "transition-all duration-300 ease-out overflow-hidden";
    
    if (shouldRender && animationClass === 'menu2025-entered') {
      return `${baseClasses} max-h-[80vh] opacity-100`;
    }
    
    return `${baseClasses} max-h-0 opacity-0`;
  };

  // Helper function for wrapper classes
  const getWrapperClasses = () => {
    return `absolute top-full left-0 right-0 z-[9999] w-full`;
  };

  return (
    <React.Fragment>
      <div className="relative flex mb-0">
        {xl && megacta && (
          <ul className="flex mb-0">
            {megacta.map((item) => (
              <li key={item.ID} className="list-none transition-all duration-200 bg-white px-4 py-4 mx-1 shadow-sm hover:bg-muotolevy-yellow">
                <a href={item.url} className="font-bold uppercase text-base text-muotolevy-red hover:text-white hover:no-underline">
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
        )}
        <MainMenu
          {...props}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
        <div className="buttons">
          <ul className="flex items-center">
            <li>
              <a
                className="flex justify-center items-center bg-muotolevy-button w-14 h-14 hover:bg-muotolevy-yellow"
                href={homeUrl}
                onClick={() => setActiveMenu(null)}
              >
                <img src={search} alt="search" />
              </a>
            </li>
          </ul>
        </div>
        {/* Always render wrapper and ChildrenMenu for smooth animations */}
        <div className={getWrapperClasses()}>
          <div 
            className={getMenuContentClasses()}
            onMouseEnter={handleSubmenuEnter} 
            onMouseLeave={handleMouseLeave}
          >
            <ChildrenMenu {...props} parentMenu={lastActiveMenu} isVisible={shouldRender} />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Menu2025;